(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
